import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/all-customers/')({
  beforeLoad: ({ context, preload }) => {
    const { featureFlags, validatePermissions, userPermissions } = context;
    const isAllowed = !!featureFlags[FeatureFlags.CustomerManagementScreen] && userPermissions.isAvalorInternalRole;
    validatePermissions({ isAllowed, preload });
  },
});
